import BaseModule from "./base-module";

class Account extends BaseModule {
  // 注册
  register(payload) {
    return this.post("/v1/customer/register", payload);
  }

  // 登录
  login(payload) {
    return this.post("/v1/login", payload);
  }

  // 获取当前登录用户的信息
  loadCustomer(payload) {
    return this.get("/v1/customer", payload);
  }

  // 发送修改密码邮件
  updatePassword(payload) {
    return this.post("/v1/customer/password", payload);
  }

  // 修改密码
  sendEmail(payload) {
    return this.post("/v1/customer/sendEmail", payload);
  }

  // 修改资料
  updateCustomer(payload) {
    return this.post("/v1/customer/update", payload);
  }

  // 修改密码
  reset(payload) {
    return this.post("/v1/customer/reset", payload);
  }

  // 谷歌一键登陆接口
  googleLogin(payload) {
    return this.post("/v1/googleLogin", payload);
  }
}

export default new Account();
